import { Box, Typography } from "@mui/material"
import { useState, useEffect } from "react";
import { CreditScore as CreditScoreIcon } from "@mui/icons-material";
export const Summary = ({setOrderList, orderList, setOrder, setSnackBarLoader, snackBarLoader}) =>{

    const total = orderList.reduce((sum, item) => sum + item.value * item.price, 0);

    const handlePay = ()=>{
        if (orderList.length > 0){
            setOrder((prev)=>({...prev, orderList}))
            setOrderList([])
            setSnackBarLoader({...snackBarLoader, snackbar:true, msg: `Order Success`, type: "success"})
        }else{
            setSnackBarLoader({...snackBarLoader, snackbar:true, msg: `Add atleast 1 product to cart`, type: "error"})
        }
    }

    return(
        <Box gap={1} sx={{display: "flex", flexDirection: "column", overflowY: "auto", height: "100%", justifyContent: "space-between"}}>
            <Box>
                <Typography sx={{fontWeight: 600}}>Order Summary:</Typography>
                {orderList.map((v, k) => (
                    <SummaryList key={k} v={v} k={k}/>
                ))}
            </Box>
            <Box width="100%" bgcolor="#FFFFFF">
                <Box minWidth="120px" display="flex" alignItems="center" mb={2}>
                    <Box width="50%"></Box>
                    <Box width="50%" display="flex" flexDirection="column" gap={.5}>
                        <Box width="100%" display="flex" alignItems="center" justifyContent="space-between" gap="8px">
                            <Box color={'#000000'} fontWeight={500} fontSize={12} lineHeight="16px" textAlign="center">Subtotal:</Box>
                            <Box color={'#000000'} fontWeight={500} fontSize={12} lineHeight="16px" textAlign="center">₱ {parseFloat(total).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Box>
                        </Box>
                        <Box width="100%" display="flex" alignItems="center" justifyContent="space-between" gap="8px">
                            <Box color={'#000000'} fontWeight={700} fontSize={16} lineHeight="16px" textAlign="center">Total:</Box>
                            <Box color={'#000000'} fontWeight={700} fontSize={16} lineHeight="16px" textAlign="center">
                                ₱ {(parseFloat(total)).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Box onClick={handlePay} sx={{bgcolor: "primary.main", p: 2, justifyContent: "center", borderRadius: 2, display: "flex", gap: 2}}>
                    <CreditScoreIcon sx={{color: "#fff"}}/>
                    <Typography sx={{textAlign: "center", color: "#fff"}}>Pay</Typography>
                </Box>
            </Box>
        </Box>
    )
}

const SummaryList = ({v, k}) =>{
    const [imgUrl, setImgUrl] = useState(null);

    useEffect(() => {
        if (!(v.file instanceof Blob)) return;

        const url = URL.createObjectURL(v.file);
        setImgUrl(url);

        return () => URL.revokeObjectURL(url);
    }, [v.file]);

    return (
        <Box>
            <Box id={`walkthrough-checkout-step-${k}`} key={k} display="flex" alignItems="center" border="1px solid #EBEBEB" borderRadius="8px" sx={{ boxShadow: '0 1px 3px rgba(0,0,0,0.05)', backgroundColor: '#fff', py: 1, px: 2 }}>
                <Box width="50px" height="50px" borderRadius="4px"  overflow="hidden" flexShrink={0} bgcolor="#f5f5f5" mr={1.5} >
                <img src={imgUrl} alt={v.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }}/></Box>
                <Box flex={1}> <Typography fontSize={14} fontWeight={500} color="#283745">{v.name}</Typography></Box>
                <Box minWidth="60px" textAlign="center"> <Typography fontSize={13}color="#555">{v.value}</Typography></Box>
                <Box minWidth="100px" textAlign="right"> <Typography fontSize={14} fontWeight={600} color="#283745">₱ {parseFloat(v.value * v.price).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Typography></Box>
            </Box>
        </Box>
    )
}